import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Dashboard from './components/Admin/Dashboard';
import AdminProfile from './components/Admin/AdminProfile';
import Login from './components/login/Login';
import DivisionPage from './components/Admin/DivisionPage';
import KvaPricingPage from './components/Admin/KvaPricingPage';
import InvoiceView from './components/Admin/InvoiceView';
import BillSummaryReport from './components/Admin/BillSummaryReport';
import ManageDivisionInfo from './components/Admin/ManageDivisionInfo';
import UserDashboard from './components/Users/UserDashboard';
import UserDivisionView from './components/Users/UserDivisionView';
import EntryForm from './components/common/EntryForm';
import RegisterView from './components/common/RegisterView';
import GPEntryForm from './components/common/GPEntryForm';
import GPRegisterView from './components/common/GPRegisterView';
import EntryPassPrintView from './components/Print/EntryPassPrintView';
import GatePassPrintView from './components/Print/GatePassPrintView';
import BillPrintView from './components/Print/BillPrintView';

// Error Boundary to catch rendering errors
class ErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 text-red-600">
          <h1>Error: {this.state.error.message}</h1>
          <p>Please check the component imports and exports in App.js.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

const App = () => {

  return (
    <ErrorBoundary>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          {/* Login Route */}
          <Route path="/" element={<Login />} />

          {/* Admin Routes */}
          <Route path="/admin/dashboard" element={<Dashboard />} />
          <Route path="/admin/profile" element={<AdminProfile />} />
          <Route path="/admin/kva" element={<KvaPricingPage />} />
          <Route path="/admin/division/:division" element={<DivisionPage />} />
          <Route path="/admin/division/:division/create-bill-summary" element={<BillSummaryReport />} />
          <Route path="/admin/division/:division/invoice/:invoiceId" element={<InvoiceView />} />
          <Route path="/admin/division/:division/entry" element={<EntryForm />} />
          <Route path="/admin/division/:division/register" element={<RegisterView />} />
          <Route path="/admin/division/:division/kva" element={<KvaPricingPage />} />
          <Route path="/admin/division/:division/manage-info" element={<ManageDivisionInfo />} />
          <Route path="/admin/division/:division/gp-entry" element={<GPEntryForm />} />
          <Route path="/admin/division/:division/gp-register" element={<GPRegisterView />} />

          {/* User Routes */}
          <Route path="/user/dashboard" element={<UserDashboard />} />
          <Route path="/user/division/:division" element={<UserDivisionView />} />
          <Route path="/user/division/:division/entry" element={<EntryForm />} />
          <Route path="/user/division/:division/register" element={<RegisterView />} />
          <Route path="/user/division/:division/gp-entry" element={<GPEntryForm />} />
          <Route path="/user/division/:division/gp-register" element={<GPRegisterView />} />

          {/* Print Routes */}
          <Route
            path="/print/entrypass/:company/:division/:ids"
            element={<EntryPassPrintView />}
          />
          <Route
            path="/print/gatepass/:company/:division/:ids"
            element={<GatePassPrintView />}
          />
          <Route path="/print/bill" element={<BillPrintView />} />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
};

export default App;